<template>
  <div style="width: 100%;height: 100%">
    <div v-loading="loading" style="width: 100%;height: calc(100% - 35px);padding: 5px 10px 5px 10px;background-color: #f2f2f2">
      <div style="height: 100%;width: 100%;overflow-y: auto">
        <div v-for="item in bookArr" :key="item.index" class="book-card">
          <div style="margin: 20px;width: calc(100% - 40px);height: calc(100% - 40px)">
            <el-row style="height: 100%">
              <el-col :span="8" style="height: 100%">
                <div class="book-card-content-left">
                  <div class="book-card-content-left-img">
                    <img src="../assets/img/bookDefault.png">
                  </div>
                </div>
              </el-col>
              <el-col :span="16" style="height: 100%">
                <div class="book-card-content-right">
                  <div class="book-card-content-right-top">
                    <strong style="font-size: 16px">{{item.name}}</strong>
                  </div>
                  <div class="book-card-content-right-bottom">
                    <el-row style="width: 100%;">
                      <el-col :span="18">
                        <div style="width: 100%">
                          <div style="padding-top: 30px;height: 25px;line-height: 25px">{{'作者：' + item.author}}</div>
                          <div class="show-span" style="-webkit-line-clamp: 3;max-height:70px;">
                            <span :title="item.desc">{{'描述：' + item.desc}}</span>
                          </div>
                          <div class="show-span" style="-webkit-line-clamp: 2;max-height: 45px;">
                            <span :title="item.note">{{'备注信息：' + item.note}}</span>
                          </div>
                        </div>
                      </el-col>
                      <el-col :span="6">
                        <div style="width: 125px;height: 125px;">
                          <vue-qr style="width: 100%;height: 100%" :text="item.qrCode"></vue-qr>
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getBookList} from '../api/book'
import VueQr from 'vue-qr'

export default {
  name: 'bookShelf',
  components: {VueQr},
  data () {
    return {
      loading: false,
      bookArr: []
    }
  },
  created () {
    this.getBookListData()
  },
  methods: {
    getBookListData () {
      this.loading = true
      let body = {
        pageIndex: 1,
        pageSize: 9999
      }
      getBookList(body).then(res => {
        this.loading = false
        this.bookArr = res.data.array
      }).catch(error => {
        console.log(error)
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>
  .book-card{
    float: left;
    width: calc(50% - 10px);
    height: 300px;
    margin: 5px;
    background-color: #ffffff;
    border-radius: 8px;
  }
  .book-card-content-left{
    width: 100%;
    height: 100%;
  }
  .book-card-content-right{
    width: 100%;
    height: 100%;
  }
  .book-card-content-left-img{
    margin: auto;
    width: 180px;
    height: 200px;
    background-color: #ffffff;
    box-shadow: 0 0 8px 0 rgba(69, 157, 255, 0.2);
    border-radius: 4px;
  }
  .book-card-content-left-img img{
    width: 100%;
    height: 100%;
    background-size: cover;
    background-repeat: no-repeat;
  }
  .book-card-content-right-top{
    width: 100%;
    height: 40px;
    line-height: 40px;
    color: #1a1a1a;
  }
  .book-card-content-right-bottom{
    width: 100%;
    height: calc(100% - 40px);
    color: #1a1a1a;
  }
  .show-span{
    padding-top: 10px;
    width: 100%;
    line-height: 25px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    word-wrap: break-word;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>



// WEBPACK FOOTER //
// src/views/bookShelf.vue